import React, { useEffect, useState } from "react";

import { calculatePrices } from "frontend/js/helpers";

export const ProductDetailPrice = ({ product, block }) => {
  if (!product) return;

  const [prices, setPrices] = useState(null);
  const currencySymbol = '$';
  const {
    margin_top_mobile,
    margin_top_desktop,
    margin_bottom_mobile,
    margin_bottom_desktop,
    icon_discount,
    body_type_discount,
    gap_prices,
    body_type_price,
    body_type_compare,
  } = block


  useEffect(() => {
    const handleSellingPlanSelected = (event) => {
      const { product: selectedProduct, prices: selectedPrices } = event.detail;
    
      if (selectedProduct && selectedPrices) {
        setPrices(selectedPrices);
      }
    };

    window.addEventListener('selling_plan_selected', handleSellingPlanSelected);

    return () => {
      window.removeEventListener('selling_plan_selected', handleSellingPlanSelected);
    };
  }, []);  

  useEffect(() => {
    async function getPrices() {
      const bundleQuantity = Number(product.metafields?.custom['product-z'] || 1);
      const pricesData = await calculatePrices(
        product,
        product.bundle?.single_item_price,
        bundleQuantity,
        product.metafields?.custom?.product_related_discount_codes
      );
    
      if (pricesData) {
        setPrices(pricesData);
      }
    }

    getPrices();
  }, [product]); 

  if (!prices) return;

  return (
    <div 
      x-cloak=""
      className={`pdp-price flex items-center gap-x-3 lg:gap-x-4
        mt-[${margin_top_mobile }px] lg:mt-[${ margin_top_desktop}px]
        mb-[${margin_bottom_mobile}px] lg:mb-[${margin_bottom_desktop}px]
      `}
      data-prodify-price-container
    >
      {prices?.discountType === 'cart' &&
        <div className="flex items-center gap-x-2">
          {icon_discount &&
            <div dangerouslySetInnerHTML={{ __html: icon_discount }} />
          }

          <span className={body_type_discount}>
            {prices?.savings}% Off
          </span>
        </div>
      }

      <div className="flex flex-row justify-between">
        <div className={`price-container product__price flex items-center gap-x-[${gap_prices}px]`}>
          <span className="sr-only">Regular Price</span>
          <span className={`product__price ${body_type_price}`}>
            {currencySymbol}{prices?.productPrice}
          </span>

          {!!prices?.savings &&
            <s className={`product__sale-price b1`}>
              {currencySymbol}{((prices?.singlePrice * prices?.quantityInBundle) / 100).toFixed(2)}
            </s>
          }
        </div>
      </div>
    </div>
  );
};
